import { render, staticRenderFns } from "./ShippingInsurancesAdmin.vue?vue&type=template&id=b43c3278&scoped=true"
import script from "./ShippingInsurancesAdmin.vue?vue&type=script&lang=js"
export * from "./ShippingInsurancesAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b43c3278",
  null
  
)

export default component.exports